<template>
  <b-navbar toggleable="lg" type="dark" class="bg-site-primary">

    
    <b-navbar-brand href="#">PPC Tests</b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>

      <b-navbar-nav >
          <b-nav-item v-for="page in pages" :key="page.href" :active="activeHref.indexOf(page.href) > -1" :to="page.href">{{ page.name }}</b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">

        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content>
            <em>{{ name }}</em>
          </template>
          <b-dropdown-item href="#" @click="logout">Logout</b-dropdown-item>
        </b-nav-item-dropdown>

      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  props: {
    pages : {
      type: Array,
      default: () => []
    },
  },
  computed: {
    name() {
      return this.$store.getters[`user/username`] || `User`
    },
    activeHref(){
      const url = window.location.href
      return url 
    }
  },
  methods: {
    logout() {
      const username = this.name
      this.$store.dispatch(`user/logout`, {username}).then(() => {
        this.$router.push('/login')
      })
      .catch(err => this.loginError = err.message)
    },
  },
};
</script>

<style lang="scss" scoped>
</style>